// extracted by mini-css-extract-plugin
module.exports = {"title":"ReferralBox_title__8rqFF","content":"ReferralBox_content__4s2vT"};